import {
  SALESDETAIL_LOADING,
  GET_SALESDETAIL,
  GET_SALESDETAIL_SUCCESS,
  GET_SALESDETAIL_FAIL,
  ADD_SALESDETAIL_SUCCESS,
  ADD_SALESDETAIL_FAIL,
  DELETE_SALESDETAIL_SUCCESS,
  DELETE_SALESDETAIL_FAIL,
  UPDATE_SALESDETAIL_SUCCESS,
  UPDATE_SALESDETAIL_FAIL,
  SALESDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  salesDetails: [],
  error: {},
};

const SalesDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESDETAIL:
          return {
            ...state,
            salesDetails: action.payload.data,
            isSalesDetailCreated: false,
            isSalesDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesDetailCreated: false,
            isSalesDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESDETAIL: {
      return {
        ...state,
        isSalesDetailCreated: false,
        loading: true,
      };
    }

    case SALESDETAIL_LOADING: {
      return {
        ...state,
        isSalesDetailCreated: false,
        loading: true,
      };
    }

    case ADD_SALESDETAIL_SUCCESS:
      return {
        ...state,
        isSalesDetailCreated: true,
        loading: false,
        salesDetails: [action.payload.data, ...state.salesDetails],
      };

    case ADD_SALESDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesDetailCreated: true,
        salesDetails: state.salesDetails.filter(
          salesDetail => salesDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesDetailCreated: true,
        salesDetails: state.salesDetails.map(salesDetail =>
          salesDetail.id.toString() === action.payload.data.id.toString() ? { ...salesDetail, ...action.payload.data } : salesDetail
        ),
      };

    case UPDATE_SALESDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesDetail;